import { Div, Span } from '@codesuma/baseline'
import { Choice } from '../../components/choice'
import rates, { IRate, UNIT_NAMES, formatAmount, formatPercent, arrow } from '../../services/rates'
import style from './index.module.css'

// One price: its name at the start, then the price in its unit over the change
// since yesterday, and the tick that puts it in the ticker at the end. The
// whole row is the tick's tap target, as in the settings.
export const RateRow = (r: IRate) => {
    const body = Div()
    body.addClass(style.body)

    const name = Div(r.name)
    name.addClass(style.name)

    const figures = Div()
    figures.addClass(style.figures)

    const price = Div(formatAmount(r.price))
    price.addClass(style.price)
    const unit = Span(UNIT_NAMES[r.unit])
    unit.addClass(style.unit)
    price.append(unit)

    const change = Div(r.change
        ? `${arrow(r)} ${formatAmount(r.change)} (${formatPercent(r.percent)})`
        : 'بدون تغییر')
    change.addClass(style.change)
    if (r.change) change.addClass(r.change > 0 ? style.up : style.down)

    figures.append(price, change)
    body.append(name, figures)

    const row = Choice('checkbox', body, { checked: rates.isShown(r.id) })
    row.on('pick', (on: boolean) => rates.show(r.id, on))
    return row
}
